import { useLanguage } from 'context/LanguageContext'
import factsTranslations from './factsTranslations'

const LOCALES: Record<string, string> = {
    ru: 'ru-RU',
    en: 'en-US',
    es: 'es-ES',
    fr: 'fr-FR',
    de: 'de-DE',
    it: 'it-IT',
    hy: 'hy-AM',
}

export const fill = (text: string, vars: Record<string, string | number>) =>
    text.replace(/\{(\w+)\}/g, (_, k) => String(vars[k] ?? ''))

/** Числа и деньги на языке сайта: USDT — словом, $ / € — знаком. */
export const useFactsFormat = (currency: string) => {
    const { language } = useLanguage()
    const locale = LOCALES[language] ?? 'en-US'
    const t = factsTranslations[language] ?? factsTranslations.en
    const fmt = (v: number, digits = 0) =>
        v.toLocaleString(locale, { maximumFractionDigits: digits })
    const short = new Intl.NumberFormat(locale, {
        notation: 'compact',
        maximumFractionDigits: 1,
    })
    const sign = currency === 'EUR' ? '€' : '$'
    const usdt = currency === 'USDT'
    const money = (v: number, digits = 0) =>
        usdt
            ? `${fmt(v, digits)} USDT`
            : `${v < 0 ? '−' : ''}${sign}${fmt(Math.abs(v), digits)}`
    const compact = (v: number) =>
        usdt ? `${short.format(v)} USDT` : `${sign}${short.format(v)}`
    const dayLabel = (day: string) =>
        new Date(`${day}T00:00:00Z`).toLocaleDateString(locale, {
            weekday: 'short',
            day: '2-digit',
            month: '2-digit',
            timeZone: 'UTC',
        })
    const dateLabel = (ms: number) =>
        new Date(ms).toLocaleDateString(locale, {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            timeZone: 'UTC',
        })
    return { t, fmt, money, compact, dayLabel, dateLabel }
}
